import React, { useMemo } from "react";

const SectionStatusGrid = ({ sections = [] }) => {
  // 1️⃣ Remove sections where id is null
  const validSections = useMemo(
    () => sections.filter((section) => section?.id != null),
    [sections]
  );

  // 2️⃣ Divide into 3 columns dynamically
  const columnCount = 3;
  const chunkSize = Math.ceil(validSections.length / columnCount);

  const sectionChunks = Array.from({ length: columnCount }, (_, i) =>
    validSections.slice(i * chunkSize, (i + 1) * chunkSize)
  );

  return (
    <div className="grid font-medium text-sm px-4 grid-cols-1 md:grid-cols-3 gap-4">
      {sectionChunks.map((chunk, colIndex) => (
        <div
          key={`col-${colIndex}`}
          className={`space-y-4 px-4 ${
            colIndex === 1
              ? "lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300"
              : "pt-4"
          }`}
        >
          {chunk.map((section, index) => {
            const isComplete = section.status === "APPROVED";

            return (
              <div
                key={section.id ?? `${section.section}-${index}`}
                className="flex items-center"
              >
                <img
                  src={isComplete ? "/done-green.svg" : "/not-done.svg"}
                  alt="Section Status"
                  className="mr-2"
                />

                <p
                  className={`ml-2 ${
                    isComplete ? "text-black" : "text-labelLightColour"
                  }`}
                >
                  {index + 1 + colIndex * chunkSize}. {section.name}
                </p>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default SectionStatusGrid;